module.exports = __webpack_public_path__ + "static/media/badge_request.c1935429.svg";